import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Form } from 'react-bootstrap';
import './uk-datepicker.scss';

const UKDatePicker = ({
    label,
    selected,
    onChange,
    error,
    minDate = null,
    maxDate = null,
    disabled = false,
    showClearButton = false,
    placeholder = 'DD/MM/YYYY'
}) => {
    return (
        <Form.Group className="mb-3">
            {label && <Form.Label>{label}</Form.Label>}
            <DatePicker
                calendarStartDay={1} // Start week on Monday (UK standard)
                className={`form-control ${error ? 'is-invalid' : ''}`}
                dateFormat="dd/MM/yyyy"
                disabled={disabled}
                dropdownMode="select"
                isClearable={showClearButton}
                maxDate={maxDate}
                minDate={minDate}
                onChange={onChange}
                placeholderText={placeholder}
                selected={selected}
                showMonthDropdown
                showYearDropdown
            />
            {error && (
                <div className="invalid-feedback d-block">
                    {error}
                </div>
            )}
        </Form.Group>
    );
};

export default UKDatePicker;